import { render } from "./BankAccount.vue?vue&type=template&id=1012dbfa&scoped=true"
import script from "./BankAccount.vue?vue&type=script&lang=js"
export * from "./BankAccount.vue?vue&type=script&lang=js"

import "./BankAccount.vue?vue&type=style&index=0&id=1012dbfa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1012dbfa"

export default script